import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage',
  templateUrl: './manage.component.html',
  styleUrls: ['./manage.component.scss']
})
export class ManageComponent implements OnInit {
  private _bookingWidgetActive = false;
  private _partnersActive = false;
  private _accountsActive = true;

  constructor() { }

  ngOnInit() {
  }

  get bookingWidgetActive(): boolean {
    return this._bookingWidgetActive;
  }

  set bookingWidgetActive(value: boolean) {
    this._bookingWidgetActive = value;
    if (value) {
      this._partnersActive = !value;
      this._accountsActive = !value;
    }
  }

  get partnersActive(): boolean {
    return this._partnersActive;
  }

  set partnersActive(value: boolean) {
    this._partnersActive = value;
    if (value) {
      this._bookingWidgetActive = !value;
      this._accountsActive = !value;
    }
  }

  get accountsActive(): boolean {
    return this._accountsActive;
  }

  set accountsActive(value: boolean) {
    this._accountsActive = value;
    if (value) {
      this._bookingWidgetActive = !value;
      this._partnersActive = !value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/manage/manage.component.ts